"use client"
import React, { useEffect, useRef, useState, memo, useMemo, useCallback } from 'react';

import SpinWrapper from "./../SpinWrapper/page"
import { Box, ModalWrapper, PageHeaderWrapper } from "../../components/wrapperComponents/page"
import { Col, DatePicker, Input, Modal, Popover, Row, Select } from 'antd';
import Helper from "../../util/helper";
import Toggle from '../buttons/toggle';
import colors from '../../libs/colorFactory';
import CalendarListView from './scheduleCalender/calendarListView';
import { useDispatch } from "react-redux";
import ViewScheduleDrawer from './ViewScheduleDrawer';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { SearchOutlined } from "@ant-design/icons";
import { PrefixIconButton, calendarActions, formatMsg, permissions, timeutil } from 'sharedresources';
import { removeItem } from '../../libs/encryptedStorage';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
const { getCalendar, getEntitySchedule } = calendarActions;
import { LeftOutlined, RightOutlined } from '@ant-design/icons'; // Import Ant Design icons
import AdminViewScheduleDrawer from './AdminViewScheduleDrawer/page';


const LaptopCalendarView: React.FC<any> = (props: any) => {
	const calendarRef = useRef<FullCalendar | null>(null);
	const {
		search,
		handleSearch,
		packageList,
		packageFilter,
		handlePackageFilterChange,
		instructorFilter,
		handleInstructorFilterChange,
		teacherMap,
		allCentersList,
		centerFilter,
		handleCenterFilterChange,
		centerMap,
		toggle,
		setToggle,
		packageMap,
		filteredCalendars,
		selectedSchedule,
		setSelectedSchedule,
		calendarReducer,
		firebase,
		mode,
		getParticipantsChildren,
		participantAttendanceStats,
		handleBatchFilterChange,
		filteredBatchList,
		batchFilter,
		batchesMap,
		view,
	} = props;

	const dispatch = useDispatch();
	let scrollRef = useRef<any>();

	// Laptop view specific things 
	const [currentMonth, setCurrentMonth] = useState(timeutil.getInstance());
	const [weekValue, setWeekValue] = useState(timeutil.getInstance());
	const [viewMode, setViewMode] = useState("dayGridMonth");
	const [viewType, setViewType] = useState("grid");
	const [popoverData, setPopoverData] = useState(null);
	const [dateToFilteredSlotsArrMap, setDateToFilteredSlotsArrMap] = useState(new Map());
	const [filteredPackageList, setFilteredPackageList] = useState<any[]>([]);


	let entityType = Helper.getUrlParam("entityType");
	const formattedEvents = entityType ? useMemo(() => {
		return filteredCalendars.map((event) => ({
			id: event.batchId,
			title: event.packageName,
			start: timeutil.getInstance(event.startTime).format(),
			end: timeutil.getInstance(event.endTime).format(),
			allDay: false,
			backgroundColor: event.color.darkColor,
			extendedProps: {
				...event
			},
		}));
	}, [filteredCalendars, packageFilter]) :
		useMemo(() => {
			return filteredCalendars.map((event) => ({
				id: event.batchId,
				title: event.packageName,
				start: timeutil.getInstance(event.startTime).format(),
				end: timeutil.getInstance(event.endTime).format(),
				allDay: false,
				backgroundColor: event.color.darkColor,
				extendedProps: { ...event },
			}));
		}, [filteredCalendars, viewMode])


	// useEffect(() => {
	// 	console.log(filteredCalendars)
	// 	if (!filteredCalendars || filteredCalendars.length === 0 || !entityType) return;

	// 	const earliestDate = filteredCalendars.reduce((earliest, current) => {
	// 		const currentDate = new Date(current.date);
	// 		return currentDate < new Date(earliest.date) ? current : earliest;
	// 	});

	// 	setWeekValue(timeutil.getInstance(new Date(earliestDate.date)));
	// }, [filteredCalendars]);

	useEffect(() => {
		let reqObj = {
			startDate: undefined,
			endDate: undefined,
		}

		switch (viewMode) {
			case "timeGridWeek":
				reqObj.startDate = timeutil.getEpoch(timeutil.getInstance(weekValue).startOf("week"));
				reqObj.endDate = timeutil.getEpoch(timeutil.getInstance(weekValue).endOf("week"));
				break;
			case "dayGridMonth":
				reqObj.startDate = timeutil.getEpoch(timeutil.getInstance(weekValue).startOf("month"));
				reqObj.endDate = timeutil.getEpoch(timeutil.getInstance(weekValue).endOf("month"));
				break;
			case "timeGridDay":
				reqObj.startDate = timeutil.getEpoch(timeutil.getInstance(weekValue).startOf("day"));
				reqObj.endDate = timeutil.getEpoch(timeutil.getInstance(weekValue).endOf("day"));
				break;
		}
		let entityType = Helper.getUrlParam("entityType");
		let id = Helper.getUrlParam("id");
		if (viewType != "gridList") {
			let id = Helper.getUrlParam("id");
			let entityType = Helper.getUrlParam("entityType");
			const calendarApi = calendarRef.current?.getApi();
			calendarApi?.gotoDate(timeutil.getInstance(reqObj.startDate).format("YYYY-MM-DD"));
			!entityType && !Helper.isAccount(firebase) && dispatch(getCalendar({ firebase, startDate: reqObj.startDate, endDate: reqObj.endDate, packageId: id ? id : null }))
		}
		if (entityType === "staff") {
			dispatch(getEntitySchedule({ firebase, entityId: id, entityType: "staff", startDate: reqObj.startDate, endDate: reqObj.endDate }));
		}
	}, [weekValue, viewMode]);

	useEffect(() => {
		let entityType = Helper.getUrlParam("entityType");
		let id = Helper.getUrlParam("id");
		if (Helper.isAccount(firebase)) {
			if (entityType === "booking") {
				dispatch(getEntitySchedule({ firebase, entityId: id, entityType: "booking" }));
			} else {
				dispatch(getEntitySchedule({ firebase, entityId: firebase.user.id, entityType: "account" }));
			}
		} else {
			if (entityType === "account") {
				dispatch(getEntitySchedule({ firebase, entityId: Helper.isAccount(firebase) ? firebase.user.id : id, entityType: "account" }));
			} else if (entityType === "user") {
				dispatch(getEntitySchedule({ firebase, entityId: id, entityType: "user" }));
			}
		}
	}, [])

	useEffect(() => {
		setViewType(toggle === 1 ? "grid" : "list")
	}, [toggle])

	function hideHeader() {
		let entityType = Helper.getUrlParam("entityType");
		return Helper.isAccount(firebase) || entityType === "account" || entityType === "user"
	}

	const handleViewChange = (view) => {
		setViewMode(view);
	};

	const handleNavigation = (action) => {
		if (viewMode !== "list" && calendarRef.current) {
			const calendarApi = calendarRef.current.getApi();
			if (action === "prev") calendarApi.prev();
			else if (action === "next") calendarApi.next();
			else if (action === "today") calendarApi.today();
			setWeekValue(timeutil.getInstance(calendarApi.getDate()).startOf("day"));
		} else {
			let currDate = timeutil.getInstance(weekValue);
			if (viewMode === "dayGridMonth") {
				if (action === "prev") currDate = currDate.subtract(1, "month");
				else if (action === "next") currDate = currDate.add(1, "month");
			} else if (viewMode === "timeGridWeek") {
				if (action === "prev") currDate = currDate.subtract(1, "week");
				else if (action === "next") currDate = currDate.add(1, "week");
			} else if (viewMode === "timeGridDay") {
				if (action === "prev") currDate = currDate.subtract(1, "day");
				else if (action === "next") currDate = currDate.add(1, "day");
			}
			setWeekValue(currDate);
		}
	};

	useEffect(() => {
		if (viewMode !== "list" && calendarRef.current) {
			const calendarApi = calendarRef.current.getApi();
			if (calendarApi) {
				calendarApi.changeView(viewMode); // Change view
				calendarApi?.gotoDate(Helper.convertToDate(weekValue, firebase)); // Change date
			}
		}

	}, [viewMode, weekValue]);

	function getDatelabelForHeader() {
		if (viewMode === "dayGridMonth") {
			return timeutil.getInstance(weekValue).format("MMMM, YYYY")
		}
		else if (viewMode === "timeGridWeek") {
			const startOfWeek = timeutil.getInstance(weekValue).startOf("week");
			const endOfWeek = timeutil.getInstance(weekValue).endOf("week");

			return `${startOfWeek.format("MMM DD, YYYY")} - ${endOfWeek.format("MMM DD, YYYY")}`;
		} else {
			return timeutil.getInstance(weekValue).format("DD MMMM, YYYY")
		}
	}

	const handleMoreClick = (info) => {
		info.jsEvent.preventDefault(); // Stop FullCalendar's default behavior
		info.jsEvent.stopPropagation(); // Stop event bubbling
		setPopoverData({
			// FullCalendar passes moreLinkClick's date as a raw UTC-midnight marker (never converted
			// to the calendar's timeZone), so read it as a plain calendar day in the school timezone.
			date: timeutil.getInstance(info.date.toISOString().slice(0, 10)),
			events: info.allSegs.map((seg) => seg.event),
			// position: { x: info.jsEvent.pageX, y: info.jsEvent.pageY }
		});
		return false;
	};

	const closePopover = () => {
		setPopoverData(null);
	};

	useEffect(() => {
		if (calendarRef.current) {
			const calendarApi = calendarRef.current.getApi();
			queueMicrotask(() => {
				calendarApi.removeAllEvents();
				calendarApi.addEventSource(formattedEvents);
			});
		}
	}, [formattedEvents]);

	useEffect(() => {

		const tempDateToFilteredSlotsArrMap = new Map();

		if (filteredCalendars) {
			filteredCalendars.forEach((slotsObj) => {
				if (!tempDateToFilteredSlotsArrMap.has(timeutil.getInstance(slotsObj.date).format('DD-MM-YYYY'))) {
					tempDateToFilteredSlotsArrMap.set(
						timeutil.getInstance(slotsObj.date).format('DD-MM-YYYY'),
						[{ ...slotsObj }]
					);
				}
				else {
					const newArr = [...tempDateToFilteredSlotsArrMap.get(
						timeutil.getInstance(slotsObj.date).format('DD-MM-YYYY')
					),
					{ ...slotsObj }];

					tempDateToFilteredSlotsArrMap.set(
						timeutil.getInstance(slotsObj.date).format('DD-MM-YYYY'),
						newArr
					);
				}
			});

			tempDateToFilteredSlotsArrMap.forEach((value, key) => {
				value.sort((a, b) => Helper.sortIntegerValue(a, b, '1740792600000'));
			});

			setDateToFilteredSlotsArrMap(tempDateToFilteredSlotsArrMap);
		}
	}, [filteredCalendars]);

	useEffect(() => {
		if (packageList && firebase) {
			console.log(packageList, "packageList")
			const filtered = packageList.filter(pkg => {
				const centerIds = pkg.centers?.map(center => center.id) || [];
				return centerIds.length > 0 &&
					permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.CALENDAR_VIEW, centerIds)
			});
			setFilteredPackageList(filtered);
		}
	}, [packageList, firebase]);

	function customDayRendering(dayProps) {

		const { day, ...buttonProps } = dayProps;
		const currDateDayjs = timeutil.getInstance(day.date);

		return (
			<button
				{...buttonProps}
				className={`${buttonProps.className} calender-date-container`}
			>
				<div className='mobile-calendar-date'>
					{currDateDayjs.format('D')}
				</div>
				<div className='calender-date-inline-metadata'>
					{getEventCircles(currDateDayjs)}
				</div>
			</button>
		);
	}
	function getEventCircles(currDateDayjs) {

		const formattedDate = currDateDayjs.format('DD-MM-YYYY');
		let daySlotsArr: any = [];

		if (dateToFilteredSlotsArrMap?.size) {
			daySlotsArr = dateToFilteredSlotsArrMap?.get(formattedDate) || [];
		}

		return (
			<>
				{
					daySlotsArr.map((slotsObj, index) => {
						return (index <= 2) ? (
							<div
								key={index}
								style={{ backgroundColor: slotsObj?.color?.darkColor || '' }}
								className='event-circle'
							/>
						)
							: null
					})
				}
			</>
		)
	}

	function getCenterName(centerId) {
		return allCentersList?.find((item) => item.id === centerId)?.name
	}
	return (
		<SpinWrapper spinning={calendarReducer.isLoading}>
			<Box style={{ paddingBottom: 0 }}>
				{!hideHeader() && <PageHeaderWrapper>
					<p className='global-page-header'>{formatMsg("sidebar.calendar")}
					</p>
				</PageHeaderWrapper>}
				<Row
					typeof='flex'
					justify={"space-between"}
					gutter={[30, 30]}
				>
					<Col
						md={8}
						lg={7}
						xl={6}
						xxl={5}
						style={{
							backgroundColor: "#F5F7FB",
							display: "flex",
							flexDirection: "column",
							// alignItems: "center",
							overflowX: "scroll"
						}}
					>
						<div className='custom-picker-container' style={{ borderBottom: "1px solid #D0D0D0", paddingBottom: "12px" }}>
							{viewMode === "timeGridDay" ?
								<div className='custom-day-picker'>
									<DayPicker
										timeZone={firebase.schoolConfig.timezone}
										onSelect={days => {
											setWeekValue(timeutil.getInstance(days))
										}}
										numberOfMonths={1}
										pagedNavigation
										showOutsideDays
										selected={Helper.convertToDate(weekValue, firebase)}
										month={Helper.convertToDate(currentMonth, firebase)}
										onMonthChange={(month) => setCurrentMonth(timeutil.getInstance(month))}
										modifiers={{
											selected: Helper.convertToDate(weekValue, firebase),
										}}
										weekStartsOn={1}
										mode='single'
										components={{
											DayButton: customDayRendering
										}}
										animate
									// disabled={disabled}
									/>
								</div>
								:
								viewMode === "timeGridWeek" ?
									<div className="custom-week-picker">
										<DatePicker.WeekPicker
											style={{ width: "100%" }}
											value={timeutil.getInstance(weekValue)}
											allowClear={false}
											onChange={(value) => {
												setViewType(prev => prev === "gridList" ? "grid" : prev)
												setWeekValue(timeutil.getInstance(value));
											}}
											open={true}
											format={Helper.customWeekStartEndFormat}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
										/>
									</div>
									:
									<div className="custom-month-picker">
										<DatePicker.MonthPicker
											allowClear={false}
											value={weekValue}
											// style={{ width: "60%" }}
											format={"MMM-YYYY"}
											onChange={(value) => {
												setViewType(prev => prev === "gridList" ? "grid" : prev)
												setWeekValue(value);
											}}
											open={true}
											getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
											size='small'
										/>
									</div>
							}
						</div>
						<div style={{ paddingLeft: "12px" }}>
							{!hideHeader() && <div style={{ marginTop: 14 }}>
								<div className='labelstyle'>{formatMsg("centers")}</div>
								<Select
									style={{ width: '90%', marginTop: "6px" }}
									popupMatchSelectWidth={false}
									mode='multiple'
									onChange={handleCenterFilterChange}
									maxTagCount={0}
									maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('center', centerFilter, centerMap)}
									value={centerFilter}
									allowClear
									placeholder={formatMsg('placeholder.selectCenters')}
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
								>
									<Select.Option key={"all"} value={"all centers"}>{formatMsg("allCenters")}</Select.Option>
									{
										allCentersList?.filter(item => permissions.hasAnyPermissionForEntity(firebase, [permissions.PERMISSIONS.CALENDAR_VIEW], [item.id])).map((item) => {
											return (
												<Select.Option key={item.id} value={item.id}>
													{item.name}
												</Select.Option>
											)
										})
									}
								</Select>
							</div>}
							{view !== "adminPackageDetailView" && entityType !== 'booking' && entityType !== 'membership' && <div style={{ marginTop: 14 }}>
								<div className='labelstyle'>{formatMsg("sidebar.packages")}</div>
								<Select
									mode='multiple'
									onChange={handlePackageFilterChange}
									maxTagCount={0}
									maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('package', packageFilter, packageMap)}
									value={packageFilter}
									style={{ width: "90%", marginTop: "6px" }}
									allowClear
									placeholder={formatMsg("placeholder.selectPackages")}
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
								>
									{filteredPackageList.length > 1 && (
										<Select.Option key={"all"} value={"all packages"}>{formatMsg("caps.allPackages")}</Select.Option>
									)}
									{filteredPackageList.map(pack =>
										<Select.Option key={pack.id} value={pack.id}>
											{pack.name}
										</Select.Option>
									)}
								</Select>
							</div>}
							{entityType !== 'booking' && entityType !== 'membership' && <div style={{ marginTop: 14 }}>
								<div className='labelstyle'>{formatMsg("sidebar.batches")}</div>
								<Select
									disabled={!packageFilter?.length}
									mode='multiple'
									onChange={handleBatchFilterChange}
									maxTagCount={0}
									maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('batch', batchFilter, batchesMap)}
									style={{ width: "90%", marginTop: "6px" }}
									placeholder={formatMsg("placeholder.selectBatches")}
									value={batchFilter}
									allowClear
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
								>
									<Select.Option
										key={"all"}
										value={"all batches"}
									>
										{formatMsg("caps.allBatches")}
									</Select.Option>
									{
										filteredBatchList?.map((item) => {
											return (
												<Select.Option key={item.id} value={item.id}>
													{item.name}
												</Select.Option>
											)
										})
									}
								</Select>
							</div>}
							{!hideHeader() && <div style={{ marginTop: 14 }}>
								<div className='labelstyle'>{formatMsg("instructors")}</div>
								<Select
									mode='multiple'
									onChange={handleInstructorFilterChange}
									maxTagCount={0}
									maxTagPlaceholder={Helper.getFilterMaxTagPlaceholder('instructor', instructorFilter, teacherMap)}
									value={instructorFilter}
									style={{ width: "90%", marginTop: "6px" }}
									allowClear
									placeholder={formatMsg("placeholder.instructors")}
									showSearch
									optionFilterProp="children"
									filterOption={(input, option) => Helper.filterOptionByChildren(input, option)}
								>
									<Select.Option value="allInstructors">{formatMsg("allInstructors")}</Select.Option>
									{Helper.getTeacherList(firebase).map((item) => (
										<Select.Option
											key={item.id}
											value={item.id}
										>
											{item.name}
										</Select.Option>
									))}
								</Select>
							</div>}

						</div>
					</Col>
					<Col
						md={16}
						lg={17}
						xl={18}
						xxl={19}
					>
						<div className={`${mode == "packageDetailView" ? "" : "fc-top-header"} pt-20`}>
							<div style={{
								marginBottom: 20,
								display: "flex",
								gap: 5,
								justifyContent: "space-between",
								alignItems: "center"
							}}>
								<div style={{
									display: "flex",
									alignItems: "center",
									gap: 15,
									marginLeft: 8
								}}>
									<div className="cl-nav-buttons">
										<LeftOutlined
											onClick={() => handleNavigation("prev")}
											style={{
												color: colors.v2_Cerulean,
												fontSize: "12px",
												marginRight: 6
											}}
										/>

										<div className="selected-date">
											<strong>{getDatelabelForHeader()}</strong>
										</div>
										<RightOutlined onClick={() => handleNavigation("next")} style={{
											color: colors.v2_Cerulean,
											fontSize: "12px",
											marginLeft: 8
										}} />
									</div>

									<div>
										<Input
											className='fc-search'
											placeholder={formatMsg("search")}
											value={search}
											onChange={(e) => handleSearch(e)}
											suffix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
										/>
									</div>
								</div>
								<div style={{ display: 'flex' }}>
									<div style={styles.colStyle}>
										{["timeGridDay", "timeGridWeek", "dayGridMonth"].map((item) => (
											<PrefixIconButton
												title={formatMsg(item)}
												backgroundColor={viewMode === item ? "var(--primary-color)" : "white"}
												fontColor={viewMode === item ? "var(--text-color)" : colors.black}
												onClick={() => handleViewChange(item)}
												borderRadius={10}
												fontWeight={400}
											/>
										))}
									</div>
									<div style={{ ...styles.colStyle, display: "flex", justifyContent: "flex-end" }}>
										<Toggle
											buttonOneTitle={<img src='/images/cal-active.png' style={{ height: 13, width: 13, margin: "auto 16px" }} />}
											buttonTwoTitle={<img src='/images/list-inactive.png' style={{ height: 13, width: 13, margin: "auto 16px" }} />}
											onToggle={(e) => {
												Helper.setUrlParam("toggle", e)
												setToggle(e)
											}}
											activeBackground={colors.color_white}
											toggle={toggle}
											selectedTextColor={"#7413BD"}
											textColor={"#5B5B5B"}
											width="fit-content"
										/>
									</div>
								</div>
							</div>
							<div className='custom-fc' ref={scrollRef} style={{ boxShadow: "0px 4px 25px 0px #0000000F", borderRadius: 10, border: "0.2px solid #D0D0D0", overflow: "auto" }}>
								{(viewType === "grid" || viewType === "gridList") &&
									<FullCalendar
										key={formattedEvents.map(event => event.id + event.start + event.title).join("-")}
										ref={calendarRef}
										timeZone={firebase.schoolConfig.timezone}
										plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, momentPlugin,
											momentTimezonePlugin]}
										initialView={viewMode}
										events={formattedEvents}
										initialDate={Helper.convertToDate(weekValue, firebase)}
										slotEventOverlap={false}
										nowIndicator={true}
										eventContent={
											// viewMode === "dayGridMonth" ?
											({ event }) => {
												return (
													<div
														style={{
															backgroundColor: Helper.hexToLightColor(event.backgroundColor), // Custom color
															color: event.backgroundColor, // Text color
															padding: "10px",
															borderRadius: "5px",
															fontSize: "var(--font-size-13)",
															border: "0.5px solid #D0D0D0",
															borderLeftColor: event.backgroundColor,
															borderLeft: "5px solid",
															fontWeight: 500,
															overflowX: "hidden",
															whiteSpace: viewMode !== "dayGridMonth" && "nowrap",
															minHeight: "100%"
														}}
														className='cl-custom-event'
													>
														<div>
															<div className='fc-event-time'><span>{timeutil.getInstance(event.start).format("hh:mm A")}</span> - <span>{event.end ? timeutil.getInstance(event.end).format("hh:mm A") : null}</span></div>
															<div className='event-title fc-event-time'>{event.title}</div>
															<div><div>{event.extendedProps.batchName}</div></div>
															<div>{getCenterName(event.extendedProps.centerId)}</div>
														</div>
														{/* <br /> */}
													</div>
												)

											}
											// : null
										}
										headerToolbar={false}
										dayMaxEvents={2}
										eventMaxStack={viewMode === "timeGridWeek" ? 2 : 6}
										dayMaxEventRows={3}
										moreLinkClick={(info) => {
											handleMoreClick(info);
										}}
										eventClick={(info) => {
											setSelectedSchedule({
												...info.event.extendedProps,
											})
										}}
										eventDidMount={(info) => {
											if (info.view.type === "timeGridWeek" || info.view.type === "timeGridDay") {
												info.el.style.backgroundColor = "transparent";
												info.el.style.border = "none";
												info.el.style.color = "#000"; // Ensure text is visible
											}

										}}
										// Header labels must be formatted by FullCalendar itself. Month view headers carry a
										// placeholder UTC-midnight weekday date (not a real date in the calendar's timeZone), so
										// re-formatting info.date with timeutil in a zone west of UTC (e.g. America/Los_Angeles)
										// labelled every column with the previous weekday.
										views={{
											dayGridMonth: {
												dayHeaderFormat: { weekday: 'short' },
												dayHeaderContent: (info) => {
													return (
														<div>
															<div className='fc-header-day'>{info.text}</div>
														</div>
													)
												}
											},
											timeGridWeek: {
												dayHeaderContent: (info) => {
													return (
														<div>
															<div className='fc-header-day'>{info.view.calendar.formatDate(info.date, { weekday: 'short' })}</div>

															<div className={info.isToday ? "fc-header-date-today" : 'fc-header-date'}>{info.view.calendar.formatDate(info.date, { day: 'numeric' })}</div>
														</div>
													)
												}
											},
											timeGridDay: {
												dayHeaderContent: (info) => {
													return (
														<div>
															<div className='fc-header-day'>{info.view.calendar.formatDate(info.date, { weekday: 'short' })}</div>

															<div className={info.isToday ? "fc-header-date-today" : 'fc-header-date'}>{info.view.calendar.formatDate(info.date, { day: 'numeric' })}</div>
														</div>
													)
												}
											}
										}}
										allDaySlot={false}
									/>
								}
								{(viewType === "list" || viewType === "gridList") &&
									<CalendarListView
										appointments={filteredCalendars}
										viewMode={viewType === "gridList" ? "day" : viewMode}
										weekValue={weekValue}
										packageMap={packageMap}
										setSelectedSchedule={setSelectedSchedule}
										firebase={firebase}
									/>
								}
							</div>
						</div>
						{
							Helper.isAccount(firebase)
								? <ViewScheduleDrawer
									selectedSchedule={selectedSchedule}
									drawerOnClose={() => {
										setSelectedSchedule(undefined)
										removeItem('selectedSchedule');
									}}
									isLoading={calendarReducer.isLoading}
									scheduleDetail={calendarReducer.scheduleDetail}
									firebase={firebase}
									getParticipantsChildren={getParticipantsChildren}
									participantAttendanceStats={participantAttendanceStats}
								/>
								: <AdminViewScheduleDrawer
									selectedSchedule={selectedSchedule}
									drawerOnClose={() => {
										setSelectedSchedule(undefined)
										removeItem('selectedSchedule');
									}}
									isLoading={calendarReducer.isLoading}
									scheduleDetail={calendarReducer.scheduleDetail}
									firebase={firebase}
									centerMap={centerMap}
									teacherMap={teacherMap}
								/>
						}

						{popoverData && (
							<ModalWrapper
								open={popoverData}
								onCancel={closePopover}
								footer={null}
								className="popover"
								width={400}

							>
								<div style={{
									maxHeight: 600,
									overflowY: "auto"
								}}>
									<div className='fc-popup-displayFlex '>
										<div className='fc-popup-day'>
											{timeutil.getInstance(popoverData.date).format("ddd").toUpperCase()}
										</div>
										<div className='fc-popup-date'>
											{timeutil.getInstance(popoverData.date).format("DD")}
										</div>
									</div>
									{popoverData.events.map((event) => (
										<div key={event.id} style={{ backgroundColor: Helper.hexToLightColor(event.backgroundColor), marginBottom: "12px", padding: "8px", display: 'flex', alignItems: "center", justifyContent: "flex-start", borderRadius: 8, cursor: "pointer" }}
											onClick={() => {
												closePopover();
												setSelectedSchedule({
													...event.extendedProps,
												})
											}}
										>
											<div style={{ backgroundColor: event.backgroundColor, marginInlineEnd: "12px" }} className='laptop-event-circle'></div>
											<div>
												<div>{timeutil.getInstance(event.start).format("hh:mm A")}{" - "}{timeutil.getInstance(event.end).format("hh:mm A")}{" "}{event.title}</div>
												<div>{event.extendedProps.batchName}</div>
												<div>{getCenterName(event.extendedProps.centerId)}</div>
											</div>
										</div>
									))}
								</div>
							</ModalWrapper>
						)}
					</Col>
				</Row>
			</Box>
		</SpinWrapper>
	);
};

export default LaptopCalendarView;

const styles: any = {
	colStyle: {
		display: "flex",
		alignItems: "center",
		flexWrap: "nowrap",
		whiteSpace: "nowrap",
		marginInlineEnd: 12
	}
}